import mountConfirm from '../services/modal_confirm';

const MODAL_TRIGGER = '.bizneo-extension-card [data-modal-confirm]';
const SELECTOR = '.bizneo-extension-card';

/**
 * MUTATION OBSERVER: Check extension installed
 */
const observer = new MutationObserver(mutationRecords => {
  mutationRecords.forEach(mutationRecord => {
    if (mutationRecord.type === 'childList') {
      if (mutationRecord.addedNodes[0]?.getAttribute?.('name') === 'bizneo-hire-extension') {
        $(SELECTOR).remove();
      }
    }
  });
});

observer.observe(document.head, {
  childList: true,
  attributeFilter: ['name'],
});

/**
 * EVENT BINDINGS
 */
$(document).on('click', `${MODAL_TRIGGER}`, async (e) => {
  e.preventDefault();
  const $el = $(e.target).data().confirm === undefined ? $(e.target).closest('[data-modal-confirm]') : $(e.target);
  const data = $el.data();
  data.confirm = data.modalConfirm;

  const confirmInstance = await mountConfirm(data);

  confirmInstance.$on('close', (ev) => {
    if (ev.detail === 'cancel-cta') {
      const monthsToExpire = new Date();
      // If Card is dismissed, it should be hidden for 3 months.
      monthsToExpire.setMonth(monthsToExpire.getMonth() + 3);
      document.cookie = `bizneo-ext-card=hidden; expires=${monthsToExpire.toUTCString()}; path=/`;
      $(document).trigger('dom-update');
    }
    confirmInstance.$destroy();
  });
  confirmInstance.$on('confirm', () => {
    window.open('https://chromewebstore.google.com/detail/bizneo-hire-extension/ngfbieoicfkeglfkceacffojkndjaehb?hl=es&pli=1', '_blank');
    confirmInstance.$destroy();
  });
});

function checkUpdate() {
  const isInstalled = !!$('meta[name="bizneo-hire-extension"]').length;
  const cookiePresent = document.cookie.includes('bizneo-ext-card');
  const isChrome = (/chrome|crios/i.test(navigator.userAgent) && !/opr|opera|chromium|edg|ucbrowser|googlebot/i.test(navigator.userAgent));

  if (isInstalled || cookiePresent || !isChrome) {
    $(SELECTOR).remove();
  }
}

$(document).on('dom-update', () => {
  checkUpdate();
});

/**
 * ON LOAD
 */
// Unless element has been removed because extension is installed, show card after .3secs
setTimeout(() => {
  $(SELECTOR).toggleClass('bizneo-extension-card--show');
}, 50);
